var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { DemographicHypeAuditorComponent } from '../demographic-hype-auditor/demographic-hype-auditor.component';
import { TranslateService } from '@ngx-translate/core';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
import { CommonConstant, pieChartConfig } from '../../../app.constants';
var NewInfluencerDemographicComponent = /** @class */ (function (_super) {
    __extends(NewInfluencerDemographicComponent, _super);
    function NewInfluencerDemographicComponent(translate, referenceDataService, pdfService, userService) {
        var _this = _super.call(this, translate, referenceDataService, pdfService, userService) || this;
        _this.maxWidthGenderChart = CommonConstant.DEMOGRAPHIC_GENDER_CHART_MAX_WIDTH;
        return _this;
    }
    NewInfluencerDemographicComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.pieLegend.useHTML = true;
        this.pieLegend.x = pieChartConfig.demographicLegendX;
        this.pieLegend.navigationActiveColor = '#445166';
        this.pieLegend.navigationInactiveColor = 'rgba(68,81,102,0.50)';
        this.pieLegend.navigationArrowSize = 10;
        this.pieTitleStyling = pieChartConfig.newTitleStyling;
        this.audienceInterestMaxValue = Math.max.apply(Math, this.demographicData.audienceInterest.map(function (item) { return Math.round(item[1] * 100); }));
        if (this.printMode) {
            this.overridenLegend = this.pieLegend;
        }
        else {
            this.overridenLegend = __assign({}, this.pieLegend, { width: 150, x: 87, align: 'center', floating: true });
        }
    };
    NewInfluencerDemographicComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    return NewInfluencerDemographicComponent;
}(DemographicHypeAuditorComponent));
export { NewInfluencerDemographicComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-influencer-demographic/new-influencer-demographic.component.ts.pre-build-optimizer.js